<modal>
  <span header>{{user.ID > 0 ? ('Chỉnh sửa' | lang) + ' ' + user.Username : ('Tạo tài khoản mới' | lang)}}</span>

  <p>{{'Tên đăng nhập' | lang}}</p>
  <input [(ngModel)]="user.Username"/>
  <p>{{'Mật khẩu' | lang}}</p>
  <input type="password" [(ngModel)]="user.Password" placeholder="{{'Để trống để tiếp tục sử dụng mật khẩu cũ' | lang}}"/>
  <p>{{'Vai trò' | lang}}</p>
  
    <div *ngFor="let i of roles" [ngClass]="{'active': is(i)}" (click)="toggle(i)" class="role">
      <b>{{info(i).name | lang}}</b>
      <br/>
      <small>{{info(i).description | lang}}</small>
    </div>  

    <div class="flex">
      <button (click)="save()" class="text-white bg-success"><i class="fa fa-save"></i><span>{{'Lưu' | lang}}</span></button>
      <button (click)="close()" class="text-white bg-warning"><i class="fa fa-arrow-left"></i><span>{{'Đóng' | lang}}</span></button>
    </div>
</modal>
